import { RootState } from '../../config';
import { IPatient } from '../../interfaces';
import {
  IPatientsBpStatusFilter,
  IPatientsFilters,
  IPatientsNewUserFilter,
  IPatientsSort,
  IPatientsState,
  IPatientsSyncStatusFilter,
} from './types';

export const selectPatients = (state: RootState): IPatientsState => state.patients;
export const selectPatientsSearchText = (state: RootState): string => state.patients.searchText;
export const selectPatientsFilters = (state: RootState): IPatientsFilters => state.patients.filters;
export const selectPatientsBpStatusFilter = (state: RootState): IPatientsBpStatusFilter =>
  state.patients.filters.bpType;
export const selectPatientsSyncStatusFilter = (state: RootState): IPatientsSyncStatusFilter =>
  state.patients.filters.syncState;
export const selectPatientsNewUserFilter = (state: RootState): IPatientsNewUserFilter => state.patients.filters.newUser;
export const selectPatientsSort = (state: RootState): IPatientsSort => state.patients.sort;
export const selectPatientById = (state: RootState, patientId: number): IPatient | undefined =>
  state.patients.patients.find((patient: IPatient) => patient.id === patientId);
